module.exports = __webpack_public_path__ + "img/recommendation-banner.0eea3511.jpg";